(function(){
'use strict';
var doc=document;
function qs(s,c){return (c||doc).querySelector(s)}
function qsa(s,c){return Array.prototype.slice.call((c||doc).querySelectorAll(s))}
function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var hasGsap=!!window.gsap;
var motion=hasGsap&&!reduced;
var MAIN='#MainContent';

function initPreloader(){
  try{
    if(reduced||sessionStorage.getItem('faunaPre'))return;
    sessionStorage.setItem('faunaPre','1');
    var pre=doc.createElement('div');pre.id='preloader';pre.setAttribute('aria-hidden','true');
    pre.innerHTML='<svg class="pre-mark" viewBox="0 0 48 48"><path class="ear" d="M31 8l6 8"/><path d="M33 12c7 4 10 14 4 21s-17 8-23 1-4-17 3-20c6-3 12 0 13 5 1 4-2 8-6 7"/><circle class="eye" cx="30" cy="17" r="2"/></svg><div class="pre-logo">Veloura</div><div class="pre-line"></div>';
    doc.body.appendChild(pre);
    setTimeout(function(){pre.classList.add('done')},2200);
    setTimeout(function(){pre.remove()},3500);
  }catch(e){}
}

var warpEl=doc.createElement('div');warpEl.id='warp';warpEl.setAttribute('aria-hidden','true');
warpEl.innerHTML='<div class="warp-veil"></div><div class="warp-glow"></div><div class="warp-ring"></div><div class="warp-ring r2"></div>';
function setAppOrigin(){if(hasGsap&&qs(MAIN))gsap.set(MAIN,{transformOrigin:'50% '+(window.scrollY+window.innerHeight/2)+'px'})}
function burst(){
  var cx=window.innerWidth/2,cy=window.innerHeight/2,vm=Math.min(window.innerWidth,window.innerHeight);
  for(var i=0;i<14;i++){
    var d=doc.createElement('div');d.className='fly-dot';
    d.style.left=(cx-5)+'px';d.style.top=(cy-5)+'px';d.style.width='9px';d.style.height='9px';
    doc.body.appendChild(d);
    var a=Math.random()*Math.PI*2,dist=vm*(.28+Math.random()*.3);
    gsap.fromTo(d,{opacity:1,scale:.6+Math.random()},{x:Math.cos(a)*dist,y:Math.sin(a)*dist,opacity:0,scale:.15,duration:.8+Math.random()*.3,ease:'power2.out',onComplete:(function(el){return function(){el.remove()}})(d)});
  }
}
var warping=false;
function warpTo(href){
  if(!motion||!qs(MAIN)){location.href=href;return}
  if(warping)return;warping=true;
  try{sessionStorage.setItem('faunaWarpIn','1')}catch(e){}
  var veil=qs('.warp-veil'),glow=qs('.warp-glow'),r1=qs('.warp-ring'),r2=qs('.warp-ring.r2');
  setAppOrigin();
  gsap.set(warpEl,{opacity:1});
  gsap.timeline()
    .to(MAIN,{scale:.9,filter:'blur(12px)',duration:.45,ease:'power3.in'},0)
    .to(veil,{opacity:1,duration:.36,ease:'power2.in'},0)
    .fromTo(glow,{scale:0,opacity:0},{scale:1.35,opacity:1,duration:.6,ease:'power2.out'},.05)
    .fromTo(r1,{scale:0,opacity:1},{scale:2.9,opacity:0,duration:.85,ease:'power2.out'},.08)
    .fromTo(r2,{scale:0,opacity:.8},{scale:3.5,opacity:0,duration:.95,ease:'power2.out'},.2)
    .add(burst,.1)
    .add(function(){location.href=href},.52);
}
function warpIn(){
  var came=false;
  try{came=sessionStorage.getItem('faunaWarpIn')==='1';sessionStorage.removeItem('faunaWarpIn')}catch(e){}
  if(!motion||!qs(MAIN))return;
  if(came){
    var veil=qs('.warp-veil');
    gsap.set(warpEl,{opacity:1});gsap.set(veil,{opacity:1});
    setAppOrigin();
    gsap.timeline({onComplete:function(){gsap.set(warpEl,{opacity:0});gsap.set(veil,{opacity:0})}})
      .fromTo(MAIN,{scale:1.06,filter:'blur(10px)'},{scale:1,filter:'blur(0px)',duration:.75,ease:'power3.out',clearProps:'transform,filter'},0)
      .to(veil,{opacity:0,duration:.55,ease:'power2.out'},.05);
  }else{
    gsap.fromTo(MAIN,{opacity:0,y:14},{opacity:1,y:0,duration:.6,ease:'power3.out',clearProps:'opacity,transform'});
  }
}
doc.addEventListener('click',function(e){
  if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  var a=e.target.closest('a[href]');
  if(!a||a.target==='_blank'||a.hasAttribute('download')||a.hasAttribute('data-no-warp'))return;
  var href=a.getAttribute('href')||'';
  if(!href||href.charAt(0)==='#'||/^(mailto:|tel:|javascript:)/i.test(href))return;
  if(a.origin&&a.origin!==location.origin)return;
  if(a.pathname===location.pathname&&a.search===location.search&&a.hash)return;
  if(/\/(checkout|cart\/add|cart\/change|account\/logout)/.test(a.pathname))return;
  e.preventDefault();
  warpTo(a.href);
});
window.addEventListener('pageshow',function(e){
  if(e.persisted&&hasGsap){gsap.set(MAIN,{clearProps:'all'});gsap.set(warpEl,{opacity:0});warping=false}
});

function tickCountdown(){
  var n=new Date(),t=new Date(n);t.setHours(23,0,0,0);
  if(n>=t)t.setDate(t.getDate()+1);
  var diff=t-n,h=Math.floor(diff/3600000),m=Math.floor(diff%3600000/60000);
  var txt=(h>0?h+' u ':'')+m+' min';
  qsa('.cd').forEach(function(el){el.textContent=txt});
}

var currentPet='all';
function setFilter(pet){
  currentPet=pet;
  qsa('.g-chip').forEach(function(c){c.classList.toggle('active',c.getAttribute('data-pet')===pet)});
  applyGridControls();
}
function applyGridControls(){
  var pillarSel=qs('#pillarFilter');
  var pillar=pillarSel?pillarSel.value:'all';
  qsa('.p-card').forEach(function(card){
    var cp=card.getAttribute('data-pet'),cpl=card.getAttribute('data-pillar');
    var petOk=(currentPet==='all'||cp===currentPet||cp==='beide');
    var pillarOk=(pillar==='all'||cpl===pillar);
    card.classList.toggle('hide',!(petOk&&pillarOk));
  });
  var sortSel=qs('#sortSelect');
  var sort=sortSel?sortSel.value:'default';
  var grid=qs('.grid10');
  if(sort!=='default'&&grid){
    var cards=qsa('.p-card',grid);
    cards.sort(function(a,b){
      if(sort==='price-asc')return (+a.getAttribute('data-price'))-(+b.getAttribute('data-price'));
      if(sort==='price-desc')return (+b.getAttribute('data-price'))-(+a.getAttribute('data-price'));
      if(sort==='name-asc')return (a.getAttribute('data-name')||'').localeCompare(b.getAttribute('data-name')||'');
      return 0;
    });
    cards.forEach(function(c){grid.appendChild(c)});
  }
}

function getFavs(){try{return JSON.parse(localStorage.getItem('faunaFavs')||'[]')}catch(e){return []}}
function setFavs(arr){try{localStorage.setItem('faunaFavs',JSON.stringify(arr))}catch(e){}}
function toggleFav(handle){
  var favs=getFavs();var i=favs.indexOf(handle);
  if(i>=0)favs.splice(i,1);else favs.push(handle);
  setFavs(favs);updateFavUI();
}
function updateFavUI(){
  var favs=getFavs();
  qsa('[data-fav-toggle]').forEach(function(b){b.classList.toggle('active',favs.indexOf(b.getAttribute('data-fav-toggle'))>=0)});
  var badge=qs('#favBadge');
  if(badge){badge.textContent=favs.length;badge.style.display=favs.length?'flex':'none'}
}
doc.addEventListener('click',function(e){
  var b=e.target.closest('[data-fav-toggle]');
  if(!b)return;
  e.preventDefault();e.stopPropagation();
  toggleFav(b.getAttribute('data-fav-toggle'));
});

/* ---------- Snel toevoegen aan winkelwagen vanuit het rooster ---------- */
function updateCartBubble(){
  fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
    qsa('.cart-count-bubble span[aria-hidden]').forEach(function(el){el.textContent=cart.item_count});
    qsa('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count});
  }).catch(function(){});
}
function quickAddToCart(btn){
  var vid=btn.getAttribute('data-add-cart');
  if(!vid||btn.disabled)return;
  var label=btn.getAttribute('data-default-label')||btn.textContent;
  btn.disabled=true;
  btn.textContent='Toevoegen…';
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:vid,quantity:1}]})
  }).then(function(r){
    if(!r.ok)throw new Error('add-failed');
    return r.json();
  }).then(function(){
    btn.textContent='Toegevoegd ✓';
    btn.classList.add('added');
    updateCartBubble();
    setTimeout(function(){btn.textContent=label;btn.disabled=false;btn.classList.remove('added')},1700);
  }).catch(function(){
    btn.textContent='Niet gelukt, probeer opnieuw';
    setTimeout(function(){btn.textContent=label;btn.disabled=false},2000);
  });
}
doc.addEventListener('click',function(e){
  var b=e.target.closest('[data-add-cart]');
  if(!b)return;
  e.preventDefault();e.stopPropagation();
  quickAddToCart(b);
});

function initBundle(){
  var box=qs('[data-fauna-bundle]');if(!box)return;
  box.addEventListener('change',function(e){
    if(e.target.name!=='fauna-bundle')return;
    var v=parseInt(e.target.value,10);if(!v)return;
    var qi=qs('quantity-input input[name="quantity"]')||qs('input[name="quantity"]');
    if(qi){qi.value=v;qi.dispatchEvent(new Event('change',{bubbles:true}))}
  });
}

var viewer=null,canvas=null;
var V={ready:false,active:false,visible:true,raf:null,group:null,
       rotX:.5,rotY:-2.2,rotXT:.12,rotYT:-.55,camZ:7.6,camZT:6.4,last:0};
function init3DOnce(){
  if(V.ready)return true;
  if(!window.THREE)return false;
  try{V.renderer=new THREE.WebGLRenderer({canvas:canvas,antialias:true,alpha:true})}catch(e){return false}
  V.renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
  V.renderer.shadowMap.enabled=true;
  V.renderer.shadowMap.type=THREE.PCFSoftShadowMap;
  if(typeof THREE.sRGBEncoding!=='undefined')V.renderer.outputEncoding=THREE.sRGBEncoding;
  V.scene=new THREE.Scene();
  V.camera=new THREE.PerspectiveCamera(38,1,.1,60);
  V.camera.position.set(0,1.05,V.camZ);
  V.scene.add(new THREE.HemisphereLight(0xffffff,0x1a1a22,.6));
  var key=new THREE.DirectionalLight(0xffffff,1.15);
  key.position.set(3.5,6,4);key.castShadow=true;
  key.shadow.mapSize.set(1024,1024);
  key.shadow.camera.left=-5;key.shadow.camera.right=5;key.shadow.camera.top=5;key.shadow.camera.bottom=-5;
  V.scene.add(key);
  var rim=new THREE.PointLight(0xC9A96A,.9,30);rim.position.set(-4,2.5,-3);V.scene.add(rim);
  var fill=new THREE.PointLight(0x2E52E8,.45,30);fill.position.set(2.5,-1,4.5);V.scene.add(fill);
  var ground=new THREE.Mesh(new THREE.PlaneGeometry(40,40),new THREE.ShadowMaterial({opacity:.3}));
  ground.rotation.x=-Math.PI/2;ground.position.y=-1.78;ground.receiveShadow=true;
  V.scene.add(ground);
  var pts=new Map(),lastX=0,lastY=0,pinchD=0;
  canvas.addEventListener('pointerdown',function(e){
    pts.set(e.pointerId,{x:e.clientX,y:e.clientY});
    lastX=e.clientX;lastY=e.clientY;V.last=Date.now();
    try{canvas.setPointerCapture(e.pointerId)}catch(err){}
  });
  canvas.addEventListener('pointermove',function(e){
    if(!pts.has(e.pointerId))return;
    pts.set(e.pointerId,{x:e.clientX,y:e.clientY});
    var arr=[];pts.forEach(function(v){arr.push(v)});
    if(arr.length===1){
      V.rotYT+=(e.clientX-lastX)*.0075;
      V.rotXT=clamp(V.rotXT+(e.clientY-lastY)*.005,-.25,.6);
      lastX=e.clientX;lastY=e.clientY;V.last=Date.now();
    }else if(arr.length===2){
      var d=Math.hypot(arr[0].x-arr[1].x,arr[0].y-arr[1].y);
      if(pinchD)V.camZT=clamp(V.camZT*(pinchD/d),4.4,9);
      pinchD=d;V.last=Date.now();
    }
  });
  function release(e){pts.delete(e.pointerId);pinchD=0;V.last=Date.now()}
  canvas.addEventListener('pointerup',release);
  canvas.addEventListener('pointercancel',release);
  viewer.addEventListener('wheel',function(e){e.preventDefault();V.camZT=clamp(V.camZT+e.deltaY*.004,4.4,9);V.last=Date.now()},{passive:false});
  if(window.ResizeObserver)new ResizeObserver(resize3D).observe(viewer);
  window.addEventListener('resize',resize3D);
  if(window.IntersectionObserver)new IntersectionObserver(function(en){V.visible=en[0].isIntersecting},{threshold:.05}).observe(viewer);
  V.ready=true;
  return true;
}
function resize3D(){
  if(!V.ready)return;
  var w=viewer.clientWidth,h=viewer.clientHeight;
  if(!w||!h)return;
  V.renderer.setSize(w,h,false);
  V.camera.aspect=w/h;V.camera.updateProjectionMatrix();
}
function disposeGroup(){
  if(!V.group)return;
  V.scene.remove(V.group);
  V.group.traverse(function(o){
    if(o.geometry)o.geometry.dispose();
    if(o.material){(Array.isArray(o.material)?o.material:[o.material]).forEach(function(m){m.dispose()})}
  });
  V.group=null;
}
function buildModel(model){
  function M(o){return new THREE.MeshStandardMaterial(o)}
  var ceramic=M({color:0xF3F4F6,roughness:.3,metalness:.06});
  var ceramic2=M({color:0xE4E7EC,roughness:.42,metalness:.04});
  var steel=M({color:0xC9CDD6,roughness:.26,metalness:.85});
  var dark=M({color:0x14141A,roughness:.45,metalness:.2});
  var g=new THREE.Group();
  function add(geo,mat,x,y,z,noShadow){
    var m=new THREE.Mesh(geo,mat);m.position.set(x,y,z);
    m.castShadow=!noShadow;g.add(m);return m;
  }
  if(model==='fountain'){
    add(new THREE.CylinderGeometry(1.78,1.5,.8,64),ceramic,0,-1.3,0);
    var rim=add(new THREE.TorusGeometry(1.74,.09,20,72),ceramic2,0,-.9,0);rim.rotation.x=Math.PI/2;
    var water=add(new THREE.CircleGeometry(1.56,64),M({color:0x3E7BFF,roughness:.06,metalness:.15,transparent:true,opacity:.75,emissive:0x1636a8,emissiveIntensity:.35}),0,-.94,0,true);
    water.rotation.x=-Math.PI/2;
    add(new THREE.CylinderGeometry(.74,.85,2.25,48),ceramic,0,.15,0);
    var dome=add(new THREE.SphereGeometry(.74,48,24),ceramic,0,1.27,0);dome.scale.set(1,.55,1);
    add(new THREE.CylinderGeometry(.32,.36,.14,32),steel,0,1.6,0);
    var neck=add(new THREE.TorusGeometry(.8,.055,16,64),M({color:0x9CD2FF,emissive:0x4FA9FF,emissiveIntensity:.9,roughness:.2}),0,1.02,0,true);
    neck.rotation.x=Math.PI/2;
    add(new THREE.SphereGeometry(.055,16,16),M({color:0xC9A96A,emissive:0xC9A96A,emissiveIntensity:1.4}),0,-.45,.86,true);
  }else if(model==='feeder'){
    add(new THREE.CylinderGeometry(1.02,1.18,2.9,48),ceramic,0,.3,0);
    var dome2=add(new THREE.SphereGeometry(1.02,48,24),ceramic,0,1.75,0);dome2.scale.set(1,.5,1);
    var sc=add(new THREE.BoxGeometry(.95,.42,.08),dark,0,1.02,1.08);sc.rotation.x=-.08;
    add(new THREE.SphereGeometry(.045,16,16),M({color:0x0FA57C,emissive:0x0FA57C,emissiveIntensity:1.2}),.32,1.03,1.14,true);
    add(new THREE.BoxGeometry(.66,.5,.5),ceramic2,0,-1,.82);
    add(new THREE.CylinderGeometry(1.28,1,.5,48),ceramic,0,-1.5,.55);
    add(new THREE.CylinderGeometry(1.06,.84,.34,48),ceramic2,0,-1.4,.55,true);
    var cols=[0xC9A96A,0xB8945A,0xD9B67C];
    for(var i=0;i<12;i++){
      var a=Math.random()*Math.PI*2,r=Math.random()*.66;
      add(new THREE.SphereGeometry(.1,10,10),M({color:cols[i%3],roughness:.8}),Math.cos(a)*r,-1.3,.55+Math.sin(a)*r*.6,true);
    }
    g.scale.setScalar(.92);
  }else if(model==='bed'){
    var ring=add(new THREE.TorusGeometry(1.42,.6,24,72),M({color:0xE8E3D6,roughness:.92}),0,-.82,0);
    ring.rotation.x=Math.PI/2;ring.scale.z=.72;
    add(new THREE.CylinderGeometry(1.28,1.28,.42,64),M({color:0xF6F2E8,roughness:.85}),0,-1.05,0);
    var st=add(new THREE.TorusGeometry(.98,.02,8,72),M({color:0xC9A96A,roughness:.4,metalness:.6}),0,-.8,0,true);
    st.rotation.x=Math.PI/2;
    var tag=add(new THREE.BoxGeometry(.38,.15,.05),dark,1.02,-.62,1.02,true);tag.rotation.y=.6;
    g.scale.setScalar(1.04);
  }else if(model==='filters'){
    for(var f=0;f<3;f++){
      add(new THREE.CylinderGeometry(1.32,1.32,.44,48),ceramic,0,-1.5+f*.8,0);
      var band=add(new THREE.TorusGeometry(1.33,.03,10,48),dark,0,-1.5+f*.8,0,true);
      band.rotation.x=Math.PI/2;
    }
    var core=add(new THREE.CircleGeometry(.6,32),M({color:0x9CD2FF,emissive:0x4FA9FF,emissiveIntensity:.8,roughness:.2}),0,.33,0,true);
    core.rotation.x=-Math.PI/2;
    g.scale.setScalar(1.02);
  }else if(model==='bowlduo'){
    add(new THREE.BoxGeometry(3.5,.3,1.5),M({color:0x7A5A3A,roughness:.6}),0,-1.55,0);
    for(var s2=-1;s2<=1;s2+=2){
      add(new THREE.CylinderGeometry(.95,.72,.6,48),ceramic,s2*.95,-1.1,0);
      add(new THREE.CylinderGeometry(.78,.58,.4,48),ceramic2,s2*.95,-1.02,0,true);
    }
    var w2=add(new THREE.CircleGeometry(.68,48),M({color:0x3E7BFF,roughness:.06,transparent:true,opacity:.7,emissive:0x1636a8,emissiveIntensity:.3}),.95,-.83,0,true);
    w2.rotation.x=-Math.PI/2;
    var kc=[0xC9A96A,0xB8945A,0xD9B67C];
    for(var k2=0;k2<8;k2++){
      var a2=Math.random()*Math.PI*2,r2=Math.random()*.42;
      add(new THREE.SphereGeometry(.1,10,10),M({color:kc[k2%3],roughness:.8}),-.95+Math.cos(a2)*r2,-.86,Math.sin(a2)*r2*.6,true);
    }
  }else if(model==='dome'){
    var shell=add(new THREE.SphereGeometry(1.5,48,32),M({color:0xE9E1CE,roughness:.95}),0,-.45,0);
    shell.scale.set(1,.82,1);
    add(new THREE.CylinderGeometry(1.35,1.45,.22,48),ceramic2,0,-1.58,0);
    var door=add(new THREE.CircleGeometry(.55,40),M({color:0x14110C,roughness:.9}),0,-.8,1.37,true);
    door.rotation.x=-.22;
    var dtag=add(new THREE.BoxGeometry(.5,.18,.05),dark,0,.42,1.24,true);
    dtag.rotation.x=-.55;
    g.scale.setScalar(1.05);
  }else if(model==='brush'){
    add(new THREE.BoxGeometry(1.9,.5,.9),ceramic,0,.95,0);
    add(new THREE.BoxGeometry(1.6,.16,.66),dark,0,1.28,0,true);
    for(var bx=-.65;bx<=.66;bx+=.26){
      for(var bz=-.2;bz<=.21;bz+=.2){
        add(new THREE.CylinderGeometry(.035,.035,.28,8),dark,bx,1.48,bz,true);
      }
    }
    add(new THREE.CylinderGeometry(.26,.34,1.9,32),ceramic,0,-.5,0);
    add(new THREE.CylinderGeometry(.36,.36,.18,32),steel,0,-1.52,0);
    add(new THREE.SphereGeometry(.08,16,16),M({color:0xC9A96A,emissive:0xC9A96A,emissiveIntensity:1.2}),0,-.15,.32,true);
    g.scale.setScalar(.95);
  }else if(model==='groom'){
    add(new THREE.CylinderGeometry(.62,.8,2.3,48),ceramic,0,-.4,0);
    var gd=add(new THREE.SphereGeometry(.62,48,24),ceramic,0,.72,0);
    gd.scale.set(1,.5,1);
    var nz=add(new THREE.CylinderGeometry(.3,.42,.8,32),steel,0,1.05,.34);
    nz.rotation.x=-.55;
    add(new THREE.CylinderGeometry(.83,.83,.42,48),dark,0,-.85,0);
    add(new THREE.SphereGeometry(.06,16,16),M({color:0x0FA57C,emissive:0x0FA57C,emissiveIntensity:1.2}),0,-.35,.78,true);
    add(new THREE.CylinderGeometry(.9,1,.2,48),ceramic2,0,-1.62,0);
    g.scale.setScalar(.98);
  }else if(model==='ball'){
    add(new THREE.SphereGeometry(1.35,48,32),M({color:0xF2F3F6,roughness:.18,metalness:.05}),0,-.43,0);
    var bnd=add(new THREE.TorusGeometry(1.36,.1,16,72),dark,0,-.43,0,true);
    bnd.rotation.x=Math.PI/2;bnd.rotation.z=.38;
    var bnd2=add(new THREE.TorusGeometry(1.36,.025,10,72),M({color:0xC9A96A,roughness:.35,metalness:.7}),0,-.43,0,true);
    bnd2.rotation.x=Math.PI/2;bnd2.rotation.z=-.32;
    add(new THREE.SphereGeometry(.09,16,16),M({color:0x0FA57C,emissive:0x0FA57C,emissiveIntensity:1.4}),.85,-.2,1.02,true);
  }else if(model==='tree'){
    var walnut=M({color:0x7A5A3A,roughness:.65});
    var sisal=M({color:0xD9C6A0,roughness:.95});
    var cream=M({color:0xF3EFE4,roughness:.85});
    add(new THREE.CylinderGeometry(1.5,1.6,.24,48),walnut,0,-1.64,0);
    add(new THREE.CylinderGeometry(.17,.17,1.9,24),sisal,-.55,-.55,0);
    add(new THREE.CylinderGeometry(.17,.17,3.1,24),sisal,.6,.05,0);
    add(new THREE.CylinderGeometry(.8,.8,.14,40),cream,-.55,.44,0);
    add(new THREE.CylinderGeometry(.85,.85,.14,40),cream,.6,1.64,0);
    var perch=add(new THREE.TorusGeometry(.5,.16,16,40),M({color:0xE7DFCC,roughness:.92}),.6,1.83,0);
    perch.rotation.x=Math.PI/2;perch.scale.z=.7;
    add(new THREE.CylinderGeometry(.42,.42,.1,40),cream,.6,1.8,0,true);
    g.scale.setScalar(.85);
  }else if(model==='snuffle'){
    var felt=M({color:0xE4D9C4,roughness:.92});
    var feltDark=M({color:0xC9BA9C,roughness:.92});
    add(new THREE.BoxGeometry(3.4,.2,2.6),felt,0,-1.62,0);
    for(var sx=0;sx<8;sx++){
      for(var sz=0;sz<6;sz++){
        var px=-1.55+sx*.44+ (Math.random()-.5)*.15, pz=-1.15+sz*.44+ (Math.random()-.5)*.15;
        var hh=.24+Math.random()*.32;
        add(new THREE.CylinderGeometry(.028,.028,hh,6),(Math.random()>.5?felt:feltDark),px,-1.5+hh/2,pz,true);
      }
    }
    g.scale.setScalar(.82);
  }else if(model==='idtag'){
    var stt=M({color:0xE4E7EC,roughness:.22,metalness:.85});
    var tag=add(new THREE.CylinderGeometry(.85,.85,.12,48),stt,0,-.15,0);
    tag.rotation.x=Math.PI/2;
    var ringT=add(new THREE.TorusGeometry(.24,.045,16,40),steel,0,.85,0,true);
    ringT.rotation.y=.3;
    var eng=add(new THREE.BoxGeometry(1.0,.16,.03),dark,0,-.15,.07,true);
    g.scale.setScalar(1.6);
  }else if(model==='shelf'){
    var oak=M({color:0xC9A96A,roughness:.6});
    add(new THREE.BoxGeometry(2.6,.2,1.2),oak,0,0,0);
    add(new THREE.BoxGeometry(.16,.6,.16),dark,-.95,-.42,-.42,true);
    add(new THREE.CylinderGeometry(.55,.55,.12,32),M({color:0xE8E3D6,roughness:.92}),0,.16,0,true);
    g.scale.setScalar(1.08);
  }else if(model==='nook'){
    var boucle=M({color:0xEDE3D0,roughness:.95});
    var oak2=M({color:0x7A5A3A,roughness:.6});
    add(new THREE.BoxGeometry(2.6,.7,1.3),boucle,0,-.65,0);
    add(new THREE.BoxGeometry(2.6,1.1,.3),boucle,0,.05,-.5,true);
    add(new THREE.BoxGeometry(.3,1.0,1.3),boucle,-1.3,-.15,0,true);
    add(new THREE.BoxGeometry(.3,1.0,1.3),boucle,1.3,-.15,0,true);
    add(new THREE.CylinderGeometry(.08,.08,.5,12),oak2,-1.1,-1.25,-.4,true);
    add(new THREE.CylinderGeometry(.08,.08,.5,12),oak2,1.1,-1.25,-.4,true);
    add(new THREE.CylinderGeometry(.08,.08,.5,12),oak2,-1.1,-1.25,.4,true);
    add(new THREE.CylinderGeometry(.08,.08,.5,12),oak2,1.1,-1.25,.4,true);
    g.scale.setScalar(.9);
  }
  V.group=g;V.scene.add(g);
  V.rotY=-2.2;V.rotYT=-.55;V.rotX=.5;V.rotXT=.12;V.camZ=7.6;V.camZT=6.4;V.last=Date.now();
}
function loop3D(){
  V.raf=requestAnimationFrame(loop3D);
  if(!V.active||!V.visible||doc.hidden)return;
  if(Date.now()-V.last>2600)V.rotYT+=.0032;
  V.rotY+=(V.rotYT-V.rotY)*.08;
  V.rotX+=(V.rotXT-V.rotX)*.08;
  V.camZ+=(V.camZT-V.camZ)*.1;
  if(V.group){V.group.rotation.y=V.rotY;V.group.rotation.x=V.rotX}
  V.camera.position.z=V.camZ;
  V.camera.lookAt(0,-.1,0);
  V.renderer.render(V.scene,V.camera);
}
function build3D(model){
  if(reduced){viewer.classList.add('no3d');return}
  if(!init3DOnce()){viewer.classList.add('no3d');return}
  viewer.classList.remove('no3d');
  disposeGroup();buildModel(model);resize3D();
}
function start3D(){if(!V.ready)return;V.active=true;resize3D();if(!V.raf)loop3D()}
function init3DWhenReady(){
  viewer=qs('#viewer');canvas=qs('#pvCanvas');
  if(!viewer||!canvas)return;
  var model=viewer.getAttribute('data-model');
  function boot(){build3D(model);start3D()}
  if(window.THREE){boot();return}
  var tries=0,t=setInterval(function(){
    if(window.THREE){clearInterval(t);boot()}
    else if(++tries>60){clearInterval(t);viewer.classList.add('no3d')}
  },80);
}

function boot(){
  doc.body.appendChild(warpEl);
  initPreloader();
  warpIn();
  tickCountdown();setInterval(tickCountdown,30000);
  qsa('.g-chip').forEach(function(c){c.addEventListener('click',function(){setFilter(c.getAttribute('data-pet'))})});
  var pillarSel=qs('#pillarFilter');if(pillarSel)pillarSel.addEventListener('change',applyGridControls);
  var sortSel=qs('#sortSelect');if(sortSel)sortSel.addEventListener('change',applyGridControls);
  updateFavUI();
  initBundle();
  init3DWhenReady();
}
if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',boot);else boot();
})();
